import { render, staticRenderFns } from "./repaymentList.vue?vue&type=template&id=608bdd0f&scoped=true"
import script from "./repaymentList.vue?vue&type=script&lang=js"
export * from "./repaymentList.vue?vue&type=script&lang=js"
import style0 from "./repaymentList.vue?vue&type=style&index=0&id=608bdd0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bdd0f",
  null
  
)

export default component.exports